import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from 'assets/lady3.png'


const _hoisted_1 = { class: "text-h1 text-weight-bold text-dark" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "bg-secondary text-white text-weight-bold text-h1" }, " Tuvimos un inconveniente ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "bg-accent2 q-mx-sm q-pa-md rounded-borders text-weight-bold" }, " Se ha producido un inconveniente en la agenda del Centro de Salud. ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Por favor, inténtalo otra vez con una de las siguientes opciones: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "rounded-borders q-py-lg" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_img, { src: _imports_0 }),
          _createVNode(_component_q_card_section, { class: "text-center" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, " ¡Lo sentimos! " + _toDisplayString($setup.patient), 1),
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-h5 text-weight-regular text-dark justify-start row column" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_avatar, {
                class: "q-ml-sm q-mb-xs",
                size: "40px",
                color: "accent2",
                "text-color": "dark",
                icon: "fi-info"
              }),
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-h4 text-dark text-weight-bold" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, {
            align: "center",
            class: "column q-gutter-y-md"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                rounded: "",
                "no-caps": "",
                color: "primary",
                label: "Selecciona otra hora",
                onClick: $setup.onOKClick
              }, null, 8, ["onClick"]),
              _createVNode(_component_q_btn, {
                rounded: "",
                "no-caps": "",
                outline: "",
                color: "primary",
                label: "Comienza una nueva búsqueda",
                onClick: $setup.onCancelClick
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}